import clsx from 'clsx';
import React from 'react';
import CustomTypography from '../CustomTypography/CustomTypography';
import useStyles from './EstadoStyles';
var Estado = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, type = _a.type, dataTestId = _a.dataTestId;
    var styles = useStyles();
    return (React.createElement("span", { className: styles.estado + " " + className },
        React.createElement("div", { className: clsx(styles.indicador, (_b = {},
                _b[styles.indicadorOk] = type === 'ok',
                _b[styles.indicadorWarning] = type === 'warning',
                _b[styles.indicadorError] = type === 'error',
                _b)) }),
        React.createElement(CustomTypography, { "data-testid": dataTestId, variant: "parrafo" }, children)));
};
Estado.defaultProps = {
    className: '',
};
export default Estado;
